import { IV3D } from '@/Interfaces/v3d';
import { Object3D } from 'three';
import { sides, v3dMaterial, v3dMesh, wardrobeItem, xyz } from '@/Interfaces/common';
import changeColor from '@/utils/changeColor';
import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';

declare let v3d: IV3D;
const redMat = new v3d.MeshBasicMaterial({
    color: 0xff0000,
});
export interface partProps extends wardrobeItem {
    model: v3dMesh;
    side: sides;
    parent: any;
}
export class Part extends WardrobeObject {
    private readonly _model: v3dMesh;
    // public width: number;
    // public height: number;
    // public depth: number;
    public offsets: xyz;
    public color = '#ff0000';
    public rotationDeg: xyz;
    public rotationRad: xyz;
    public childPosition: xyz;
    private material: v3dMaterial;
    parent = null;

    constructor({
        model,
        width = 1,
        height = 1,
        depth = 1,
        offsets = [ 0,0,0 ],
        rotation = [ 0, 0,0 ],
        childPosition = [ 0,0,0 ],
        scale,
        uuid,
        type,
        color,
        side,
        parent = null,
    }: partProps) {
        super({ color, side, uuid, width, height, depth, type });
        this._model = model.clone() as v3dMesh;
        this.material = this._model.material;
        this._model.name = uuid;
        this.offsets = offsets || [ 0,0,0 ];
        this.rotationDeg = rotation || [ 0,0,0 ];
        this.rotationRad = this.rotationDeg.map((angle)=>angle*Math.PI/180) as xyz;
        this._model.position.set(...this.offsets);
        this._model.rotation.set(...this.rotationRad);
        if (scale)
            this._model.scale.set(...scale);
        this.model.add(this._model);
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.childPosition = childPosition;
        this.show();
        this.parent = parent;
        if (color)
            this.setColor(color);
    }

    show() {
        this._model.visible = true;
    }

    hide() {
        this._model.visible = false;
    }

    redMark() {
        this._model.material = redMat;
    }

    noMark() {
        this._model.material = this.material;
    }

    setColor(hex: string) {
        this.noMark();
        this.color = hex.replace('#','');
        const color = hex.startsWith('#')?hex:'#'+hex;
        changeColor(this._model, 'RGB', color);
    }
}
